import loadable from '@loadable/component';
import { Loader } from '@/components';

export const AsyncWithdrawContractIntroConfirm = loadable(
  () => import('./IntroConfirm'),
  { fallback: <Loader /> },
);
